import { render, staticRenderFns } from "./odds-fast-2.vue?vue&type=template&id=5b9382a2&"
import script from "./odds-fast-2.vue?vue&type=script&lang=js&"
export * from "./odds-fast-2.vue?vue&type=script&lang=js&"
import style0 from "./odds-fast-2.vue?vue&type=style&index=0&id=5b9382a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports